module.exports = __webpack_public_path__ + "static/media/top-hero-business@2x.a290f358.jpg";